import React from "react"
import { FormControl } from "react-bootstrap"
import styled from "styled-components"
import CurrencyInput from "react-currency-input"
import Button from "../../../../../_components/Button"
import Modal from "../../../../../_components/Modal"
import Text from "../../../../../_components/Text"
import LoadingInput from "../../../../../_components/LoadingInput"
import { createCOFINS, updateCOFINS } from "../../../../../api/products/taxes"
import * as colors from "../../../../../assets/_base/colors"
import { showSnackBar } from "../../../../../utils"

export const cofinsCstdata = [
    {
        value: "99",
        label: "Outras Operações"
    },
    {
        value: "01",
        label: "Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))"
    },
    {
        value: "02",
        label: "Operação Tributável(base de cálculo = valor da operação(alíquota diferenciada))"
    },
    {
        value: "03",
        label: "Operação Tributável(base de cálculo = quantidade vendida x alíquota por unidade de produto)"
    },
    {
        value: "04",
        label: "Operação Tributável(tributação monofásica(alíquota zero))"
    },
    {
        value: "05",
        label: "Operação Tributável(Substituição Tributária)"
    },
    {
        value: "06",
        label: "Operação Tributável(alíquota zero)"
    },
    {
        value: "07",
        label: "Operação Isenta da Contribuição"
    },
    {
        value: "08",
        label: "Operação Sem Incidência da Contribuição"
    },
    {
        value: "09",
        label: "Operação com Suspensão da Contribuição"
    },
    {
        value: "49",
        label: "Outras Operações de Saída"
    },
    {
        value: "50",
        label: "Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno"
    },
    {
        value: "51",
        label: "Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno"
    },
    {
        value: "52",
        label: "Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação"
    },
    {
        value: "53",
        label: "Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não - Tributadas no Mercado Interno"
    },
    {
        value: "54",
        label: "Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação"
    },
    {
        value: "55",
        label: "Operação com Direito a Crédito - Vinculada a Receitas Não - Tributadas no Mercado Interno e de Exportação"
    },
    {
        value: "56",
        label: "Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não - Tributadas no Mercado Interno, e de Exportação"
    },
    {
        value: "60",
        label: "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno"
    },
    {
        value: "61",
        label: "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno;"
    },
    {
        value: "62",
        label: "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação"
    },
    {
        value: "63",
        label: "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não - Tributadas no Mercado Interno"
    },
    {
        value: "64",
        label: "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação"
    },
    {
        value: "65",
        label: "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não - Tributadas no Mercado Interno e de Exportação"
    },
    {
        value: "66",
        label: "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não - Tributadas no Mercado Interno, e de Exportação"
    },
    {
        value: "67",
        label: "Crédito Presumido - Outras Operações"
    },
    {
        value: "70",
        label: "Operação de Aquisição sem Direito a Crédito"
    },
    {
        value: "71",
        label: "Operação de Aquisição com Isenção"
    },
    {
        value: "72",
        label: "Operação de Aquisição com Suspensão"
    },
    {
        value: "73",
        label: "Operação de Aquisição a Alíquota Zero"
    },
    {
        value: "74",
        label: "Operação de Aquisição sem Incidência da Contribuição"
    },
    {
        value: "75",
        label: "Operação de Aquisição por Substituição Tributária"
    },
    {
        value: "98",
        label: "Outras Operações de Entrad"
    }
]
const TextButton = styled.p`
    margin-top: 2px;
    cursor: pointer;
    padding: 5px;
    color: ${colors.darkBlue};
    font-weight: bold;
`

export default props => {
    const ref = React.useRef(null)
    const [loading, setLoading] = React.useState(false)
    const [show, setShow] = React.useState(false)
    const [data, setData] = React.useState({ calculo: 0, p_cofins: 0, cst: "99" })

    function onHideModal() {
        if (loading) {
            return
        }
        setShow(false)
        setData({ calculo: 0, p_cofins: 0, cst: "99" })
        if (props.onClose) {
            props.onClose()
        }
    }
    function onChange({ target }) {
        const { name: key, value } = target
        setData({
            ...data,
            [key]: value
        })
    }
    function onSave() {
        if (!data.name) {
            showSnackBar("O nome é obrigatório!")
            try { document.querySelector('[name="name"]').focus() } catch (error) { }
            return false
        }
        let request = data.id ? updateCOFINS : createCOFINS
        setLoading(true)
        request(data)
            .then(cofins => {
                setShow(false)
                if (props.onSave) {
                    props.onSave(cofins)
                }
                showSnackBar("COFINS salvo com sucesso!", "info")
            })
            .catch(error => {
                showSnackBar("Erro ao salvar o COFINS!")
                setLoading(false)
            })
            .finally(() => {

                setTimeout(() => {
                    setData({ calculo: 0, p_cofins: 0, cst: "99" })
                    setLoading(false)
                }, 5000)
            })
    }
    function open() {
        if (props.show === true) {
            setData({ ...props.data })
        }
    }
    React.useEffect(open, [props.show])
    return <React.Fragment>
        {
            props.textButton ? <TextButton onClick={() => setShow(true)}>
                Criar Modelo COFINS
            </TextButton>
                : <Button onClick={() => setShow(true)}>
                    Criar Modelo COFINS
                </Button>
        }
        <Modal title="Modelo COFINS" show={props.show || show} onHide={onHideModal}>
            <div className="containr">
                <div className="row">
                    <div className="col-md-4">
                        <Text>
                            Nome
                        </Text>
                        <LoadingInput
                            loading={loading}
                            value={data.name}
                            name="name"
                            onChange={onChange} />
                    </div>
                    <div className="col-md-4">
                        <Text>
                            CST COFINS
                        </Text>
                        <FormControl
                            disabled={loading}
                            name="cst"
                            onChange={onChange}
                            as="select">
                            <option value="" selected disabled>Selecione o CST</option>
                            {
                                cofinsCstdata.map((cofins, idx) => {
                                    return <option
                                        value={cofins.value}
                                        selected={data.cst === cofins.value}
                                        key={`cofins-select-list-${cofins.value}${idx}`}>
                                        {cofins.value}-{cofins.label}
                                    </option>
                                })
                            }
                        </FormControl>
                    </div>
                    <div className="col-md-4">
                        <Text>
                            Alíquota COFINS
                        </Text>
                        <CurrencyInput
                            className="form-control"
                            name="p_cofins"
                            suffix=" %"
                            value={data.p_cofins}
                            onChange={(a, b, c) => onChange({ target: { name: "p_cofins", value: b } })}
                            disabled={loading}
                            maxLength={100} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-end">
                            <Button
                                disabled={loading}
                                onClick={onSave}>
                                Salvar COFINS
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/COFINS/Template/index.jsx